import React from "react";
import { useDropzone } from "react-dropzone";

function Dropzone({ onDrop, accept, open }) {
  const { getRootProps, getInputProps, isDragActive, acceptedFiles } =
    useDropzone({
      accept,
      onDrop,
      maxFiles: 1
    });

  const files = acceptedFiles.map((file) => {
    return (
      <li key={file.path}>
        {file.path} - {file.size} bytes <button className="bg-white border-0" type="button" onClick={() => { acceptedFiles.pop() }}>&#x2715;</button>
      </li>
    )
  });

  return (
    <div>
      <div {...getRootProps({ className: "dropzone" })} className="drag-n-drop-input">
        <input className="input-zone" {...getInputProps()} />
        <div className="text-center">
          {isDragActive ? (
            <p className="dropzone-content">
              Release to drop the file here
            </p>
          ) : (
            <p className="dropzone-content">
              Drag' n' drop some file here, or click to select file
            </p>
          )}
          <button type="button" onClick={open} className="btn">
            Click to select file
          </button>
        </div>
      </div>
      <aside>
        <ul>{files}</ul>
      </aside>
    </div>
  );
}

export default Dropzone;